import { getSearchParams } from '@wix/package-picker-shared';
import {
  EclipsePackagePickerSteps,
  useDomainIntent,
  useEclipseAiContent,
} from '@wix/package-picker-shared-eclipse';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';

/**
 * Resolves the tier-2, AI-personalized page title for the plan-selection step.
 *
 * Returns a concrete `aiTitle` string only when the AI content experiment is
 * on, the user is on the plan step, and no tier-1 title (downgrade / domain /
 * domain-purchase-intent) takes precedence.
 */
export const useAiPlanTitle = () => {
  const step = EclipsePackagePickerModule.internals.hooks.useCurrentStep();
  const { showDomain, shouldShowDomainNameInTitle } = useDomainIntent();
  const { isDowngradeEnabled } = getSearchParams();
  const { pageTitle: aiTitle, isLoading } = useEclipseAiContent();

  const isPlanStep =
    step === EclipsePackagePickerSteps.SELECT_PLAN ||
    step === EclipsePackagePickerSteps.ANY;
  const tier1PlanTitleApplies =
    isDowngradeEnabled || shouldShowDomainNameInTitle || showDomain;

  return {
    aiTitle: isPlanStep && !tier1PlanTitleApplies ? aiTitle : undefined,
    isLoading: isPlanStep && isLoading,
  };
};
